import { axios } from '@/utils/request'
import { passwordEncryption } from '@/utils/util'
import _ from 'lodash'

const api = {
  UserInfo: '/merchant.php/User/getInfo',
  Logout: '/merchant.php/User/logout',
  Login: '/merchant.php/User/login',
  MenuList: '/merchant.php/User/getMenu',
  updatePasswd: '/merchant.php/User/updatePasswd',
  loginbytoken: '/merchant.php/User/loginbytoken'
}

export function login (tenantCode, account, password, code) {
  const pwdEncrypt = passwordEncryption(password)
  return axios({
    url: api.Login,
    method: 'post',
    data: {
      tenantCode,
      account,
      code,
      password: pwdEncrypt
    }
  })
}

export function loginbytoken (access_token) {
  return axios({
    url: api.loginbytoken,
    method: 'post',
    data: {
      access_token
    }
  })
}

export function logout () {
  return axios({
    url: api.Logout,
    method: 'post'
  })
}

export function getUserInfo () {
  return axios({
    url: api.UserInfo,
    method: 'get'
  })
}

export function getUserPermission () {
  return axios({
    url: api.MenuList,
    method: 'get'
  })
    .then(res => {
      // 将权限表序列化
      if (_.get(res, 'code') === 200) {
        // return _.get(res, 'data', [])
        return _.map(_.get(res, 'data', []), res => res.auth_path)
      }
      return res
    })
}

export function updatePasswd (data) {
  return axios({
    url: api.updatePasswd,
    method: 'post',
    data: data
  })
}
